"use client"
import React, { useEffect, useRef, useState } from 'react'
import DramaList from '../component/DramaList'
import watch from "./watch.module.css"
import LoadMore from '../component/loadmore/LoadMore';
import { useWatchNowStore } from '../store/localapi';
import InFeedAd from '../component/ad/InFeedAd';

interface Drama {
  d_id: string;
  d_image: string;
  d_name: string;
  gradient: string;
  total_d_stream: string;
  type: string;
  unlock_count: string;
  epi_num: string;
  id: string
  image_url: string;
  drama_name: string;
  d_desc: string;
  added_dt: string;
}
type WatchNowProps = {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  dramas: Drama[];
};

async function fetchMoreDramas(currentpage: number) {
  try {
    const res = await fetch('https://dramasstory.com/web/drama_list.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ "currentpage": currentpage }),
      cache: 'no-store'
    });
    if (!res.ok) throw new Error('Network response was not ok');
    const data = await res.json();
    return data?.data?.Data || [];
  } catch (error) {
    console.error('Failed to fetch dramas:', error);
    return [];
  }
}

function WatchNow({ dramas }: WatchNowProps) {
  const { dramas: cached, currentPage, latestCount, setInitial, append } = useWatchNowStore();
  const [loading, setLoading] = useState(false);
  const lastRequestedPageRef = useRef<number | null>(null);


  // Initialize cache once per tab: if empty, seed with server data; else use cache
  useEffect(() => {
    if (!cached || cached.length === 0) {
      setInitial(dramas, 1, dramas.length);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLoadMore = async () => {
    if (loading) return;
    const nextPage = currentPage + 1;

    if (lastRequestedPageRef.current === nextPage) return;
    lastRequestedPageRef.current = nextPage;

    setLoading(true);
    try {
      const newDramas = await fetchMoreDramas(nextPage);
      append(newDramas as any);
    } catch (error) {
      console.error('Error loading more dramas:', error);
    } finally {
      setLoading(false);
      lastRequestedPageRef.current = null;
    }
  }


  return (
    <div>
      <div className={watch.watchNow}>
        <h2>Watch Now</h2>
      </div>
      <div className={watch.watchDramasBg}>
        <div className="container">
          {/* In-Feed Ad */}
          <InFeedAd style={{ margin: '20px 0' }} />
          
          <DramaList dramas={cached && cached.length ? (cached as any) : dramas} allEp={true} isTag={true} />
          {latestCount >= 10 && <LoadMore onClick={handleLoadMore} />}
          {/* {latestCount >= 10 && <button onClick={handleLoadMore}>{loading ? 'Loading...' : 'Load More'}</button>} */}
        </div>
      </div>
    </div>
  )
}

export default WatchNow